/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridSortDescriptionsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSortDescriptionsChangedEventArgs, _super);
    function GridSortDescriptionsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._sortDescriptions = null;
        return _this;
    }
    Object.defineProperty(GridSortDescriptionsChangedEventArgs.prototype, "sortDescriptions", {
        get: function () {
            return this._sortDescriptions;
        },
        set: function (a) {
            this._sortDescriptions = a;
        },
        enumerable: true,
        configurable: true
    });
    GridSortDescriptionsChangedEventArgs.$t = markType(GridSortDescriptionsChangedEventArgs, 'GridSortDescriptionsChangedEventArgs', EventArgs.$);
    return GridSortDescriptionsChangedEventArgs;
}(EventArgs));
export { GridSortDescriptionsChangedEventArgs };
//# sourceMappingURL=GridSortDescriptionsChangedEventArgs.js.map
